import styled from '@emotion/styled';

import type { TAntiFraudButtonStyleConfig } from './anti-fraud-message.types';

const MessageWrapper = styled.section`
	padding: 3px 9px;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 0 9px;
	}
`;

export const AntiFraudMessage = styled(MessageWrapper)`
	.anti-fraud-wrapper {
		pointer-events: none;
		margin: 9px 0;
	}
`;

export const AntiFraud = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;

	background: ${({ theme }) => theme.colors.gray1};
	border-radius: 8px;

	color: #fff;

	padding: 18px 20px;
	margin: 0 auto;

	width: 100%;

	.warningIcon {
		path {
			fill: #fff;
		}
	}

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 20px 23px;
	}
`;

export const Button = styled.button<TAntiFraudButtonStyleConfig>`
	display: flex;
	align-items: baseline;
	align-self: baseline;
	justify-content: center;

	position: relative;

	background: transparent;

	height: 100%;
	min-width: 20px;
	width: 20px;

	svg {
		& > circle {
			width: 20px;
			height: 20px;

			stroke-dasharray: 54;
			stroke-dashoffset: 0;

			animation: loadingCircle ${({ secondsOpen }) => `${secondsOpen}s`} 0.5s linear forwards;

			@keyframes loadingCircle {
				to {
					stroke-dashoffset: 54;
				}
			}
		}

		&.closeIcon {
			pointer-events: auto;
			position: absolute;
			right: 5px;
			top: 6px;

			width: 9px;
			height: 9px;

			path {
				fill: #fff;
			}
		}
	}
`;

export const TextWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: left;

	margin-right: 21px;

	svg {
		margin: 2px 10px 0 0;

		height: 18px;
		width: 18px;
		min-width: 18px;

		path {
			fill: #fff;
		}

		@media ${({ theme }) => theme.medias.desktop} {
			margin-right: 19px;
		}
	}
`;

export const Text = styled.p`
	font-size: 12px;
	line-height: 18px;
	color: #fff;
	font-weight: ${({ theme }) => theme.typography.weight.thin};

	strong {
		font-weight: ${({ theme }) => theme.typography.weight.extraBold};
	}

	span {
		display: inline-block;
	}
`;
